import React, { Component } from "react";

export default class GamingImg extends Component {
  render() {
    return <img alt="" src="monitor.png"></img>;
  }
}
